import React from 'react';
import Navbar from './Navbar';
import ContextBar from './ContextBar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <ContextBar />
      <main className="flex-1 px-6 py-6">
        {children}
      </main>
    </div>
  );
};

export default Layout;